import Loadable from '../../components/loadable';

const GradingEventMessages = Loadable({
  loader: () => import('../../pages/gradings/grading_event_messages'),
  type: 'block',
});

angular.module('gym').value('GradingEventMessages', GradingEventMessages);
